<script>
import Layout from "../../../router/layouts/print";

/**
 * Screen component
 */
/* eslint-disable no-console */

export default {
  components: { Layout },
  data() {
    return {
      contract: null,
    };
  },
  mounted() {
    // this.contract = {
    //       do_date: "ថ្ងៃទី១២ ខែមីនា ឆ្នាំ២០២៣",
    //       do_code: "NOLPC112-03032023",
    //       contract_code: "HSELL-03032023",
    //       contract_date: "ថ្ងៃទី១២ ខែមីនា ឆ្នាំ២០២៣",
    //       customer_name: "រិន ម៉ានេត",
    //       unit_code: "C1-12",
    //       unit_floor: "12",
    //       late_from_date: "ថ្ងៃទី១២ ខែមីនា ឆ្នាំ២០២២",
    //       gm: "",
    //   };
  },
  // watch: {
  //   data: function() {}
  // },
  watch: {
      data: function(newVal) { // watch it
        // console.log("AAAA", newVal);
        this.contract = newVal;

      }
  },
  methods: {},
  props: {
    data: null,
  }

};
</script>
<template>
  <Layout>
        <center>
          
          <div class="col dblack box-a4-long khk">
            <p class="khm title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="enb h5 l4" style="margin-top: 0.2cm;">KINGDOM OF CAMBODIA</p>
            <p class="khm h5 l6">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="enb h5 l4">NATION RELIGION KING</p>
            <p class="top-0">
              <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <table width="100%" class="doc-content">
              <tr>
                <td style="text-align: left;">
                  <img src="../../../assets/images/logoVertical.png" style="width: 200px;"/>
                </td>
                <td style="text-align: right;" class="h7">
                  <span>ធ្វើនៅភ្នំពេញ, ថ្ងៃទី {{contract && contract.do_date}}</span><br>
                  <span class="cn">金边市, {{contract && contract.do_date_en}}</span><br>
                  លេខ<span class="cnb h7">/编号: {{contract && contract.do_code}}</span>
                </td>
              </tr>
            </table>
            <p class="khm sub-title top3" style="margin-top: -0px;">សេចក្តីជូនដំណឹង ស្តីពីការ</p>
            <p class="khm sub-title top3" style="margin-top: -0px;">យឺតយ៉ាវបង់ប្រាក់ថ្លៃទិញលំនៅឋាន</p>
            <p class="cnb sub-title top3" style="margin-top: -0px;">关于迟误支付住宅买卖款之通知书</p>
            <br>
            <table width="100%" class="doc-content top text-justify">
              <tr>
                <td width="10%"><p>&nbsp;</p></td>
                <td width="90%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td>
                  <p class="khm">យោងៈ</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  - កិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានលេខៈ {{contract && contract.contract_code}} ចុះថ្ងៃទី {{contract && contract.contract_date}}។
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="cnb">参照：</p>
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                  - {{contract && contract.contract_code}} {{contract && contract.contract_date_en}} 签订的住宅买卖协议。
                  </p>
                  <p style="text-align: justify; line-height: 2em;">
                  - សេចក្តីជូនដំណឹង ស្តីពីការយឺតយ៉ាវបង់ប្រាក់ <span class="khb" style="font-weight: bold;">លើកទី១</span> លេខៈ {{contract && contract.inform1_code}} ចុះថ្ងៃទី {{contract && contract.inform1_date}}។ <br>
                  </p>
                  <p class="cn" style="text-align: justify;">
                  - {{contract && contract.inform1_code}} {{contract && contract.inform1_date_en}} 签订的迟误支付住宅买卖款的第一次通知书。
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p style="text-align: justify; text-indent: 10%; line-height: 2em">
                    <span class="khm">ក្រុមហ៊ុន លំនៅឋាន អេចស៊ី ឯ.ក</span> សូមជម្រាបជូនដំណឹងដល់ឈ្មោះ 
                    <span class="khm" style="font-weight: bold;">{{contract && contract.customer_name}}</span> ឱ្យបានជ្រាបថា៖ ការបង់ប្រាក់ថ្លៃទិញខុនដូ
                    យូនីកលេខៈ 
                    <span class="khm" style="font-weight: bold;">{{contract && contract.unit_code}} ជាន់ទីៈ {{contract && contract.unit_floor}}</span>
                    បានយឺតយ៉ាវចាប់តាំងពីថ្ងៃ {{contract && contract.late_from_date}} រហូតមកដល់ថ្ងៃបច្ចុប្បន្ននេះ ។ ដូច្នេះសូមអញ្ជើញឈ្មោះ 
                    <span class="khm" style="font-weight: bold;">{{contract && contract.customer_name}} មកបង់ប្រាក់ បូករួមទាំងប្រាក់ពិន័យ</span>
                     ដែលបានយឺតយ៉ាវជូនក្រុមហ៊ុន កុំឱ្យហួសកាលកំណត់ក្នុងកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋាន ដែលមានយោងមកខាងលើក្នុងប្រការ 3 ចំណុច 3.2 ។
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="cn">
                  <p style="text-align: justify; text-indent: 10%; line-height: 2em">
                    <span class="cnb">LOMNOV THAN HC CO., LTD.</span> 公司在此通知 
                    <span class="cnb">{{contract && contract.customer_name_en}}</span>
                    以知悉：
                    <span class="cnb">第{{contract && contract.unit_code}}, 层 {{contract && contract.unit_floor}}</span>
                    号公寓单位的买卖款给付已经从 {{contract && contract.late_from_date_en}} 迟误至今。因此，请
                    <span class="cnb">{{contract && contract.customer_name_en}}</span>
                    按照住宅买卖协议第3条第3.2项在规定期限内支付买卖款和迟误罚款给公司。 
                  </p>
                </td>
              </tr>
            </table>
            <br/>
            <table width="100%">
              <tr>
                <td width="70%"></td>
                <td width="30%">
                  <p style="text-align: center; font-size: 12pt" class="khm">ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <p style="text-align: center; font-size: 12pt" class="cnb l1">总经理</p>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <p>
                    <br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">{{contract && contract.gm}}</p>
                  <p style="text-align: center; font-size: 12pt" class="enb l1">{{contract && contract.gm_en}}</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>